/**
 * Klasse STIRLING_PORTAL_EMBED_NARROW
 * Polar: VERBOTEN eigener PDF-Editor / frame-src * / Firma-nginx mit pdf-labor /
 *        iframe wenn Origin nicht https://pdf-labor.arkorbit.at /
 *        iframe auf Firma-Portal (portal.arkorbit.at).
 *        ERLAUBT Labor/Thomas: Stirling iframe genau dieser Origin; Fallback-Tab sekundär.
 *        fail-closed: unbekannte Origins = nur ehrlicher Link, kein Fake-iframe.
 *
 * Host-Check spiegelt isLaborPortalHostname + isThomasPortalHostname in constants.ts
 * (kein Import: Node-Tests laden constants.ts nicht wegen import.meta.env).
 */

export const PORTAL_STIRLING_EMBED_CLASS = 'STIRLING_PORTAL_EMBED_NARROW';

/** Kanonische Labor-Origin — nicht Firma, nicht Wildcard, nicht stirlingpdf.com. */
export const LABOR_STIRLING_PDF_ORIGIN = 'https://pdf-labor.arkorbit.at';

function portalHostname(explicit?: string): string {
  if (explicit && explicit.trim()) return explicit.trim().toLowerCase();
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname.toLowerCase();
  }
  return '';
}

function isLaborOrThomasHostForStirling(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return (
    host === 'lab.arkorbit.at' ||
    host.includes('portal-labor') ||
    /\.labor\.arkorbit\.at$/i.test(host) ||
    host.endsWith('-labor.arkorbit.at') ||
    host === 'thomas.arkorbit.at'
  );
}

/**
 * iframe-src nur Labor-Stirling-Origin und nur auf Labor/Thomas-Portal-Hosts.
 * Polar: VERBOTEN Wildcard / fremde PDF-SaaS / pdf-labor auf Firma-Portal.
 */
export function isAllowedStirlingEmbedSrc(url: string, hostname?: string): boolean {
  const host = portalHostname(hostname);
  if (!isLaborOrThomasHostForStirling(host) || !String(url || '').trim()) return false;
  try {
    return new URL(url).origin === LABOR_STIRLING_PDF_ORIGIN;
  } catch {
    return false;
  }
}
